import React from "react";
import { Box, Typography } from "@mui/material";
import { ReactElement } from "react";
import styles from "./styles.module.scss"
import { useAppSelector } from "redux/hooks";

export default function LoginHistoryTable(): ReactElement {
  const loginHistory = useAppSelector((state => state.wallet.loginHistory))
  return (
    <Box className={styles.loginHistoryTable}>
      <Box className={styles.tableBody}>
        <Typography className={styles.tableTitleDate}>Login Date</Typography>
        <Typography className={styles.tableTitleIp}>Login ip</Typography>
      </Box>

      <Box className={styles.bodyTable}>
        <Box className={styles.loginDate}>
          {loginHistory?.records.map((el: any, index: any) => (
            <Typography key={index} className={styles.date}>{el.login_at}</Typography>
          ))}
        </Box>
        <Box className={styles.loginIp}>
          {loginHistory?.records.map((el: any, index: any) => (
            <Typography key={index} className={styles.ip}>{el.login_ip}</Typography>
          ))}
        </Box>
      </Box>
    </Box>
  );
}